module.exports = __webpack_public_path__ + "img/undraw_filter_4kje.56d5c281.svg";